"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4230],{

/***/ 60988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ LeadCategory; }
/* harmony export */ });
var LeadCategory;
(function(LeadCategory) {
    LeadCategory["SweepsImage"] = "sweepsImage";
    LeadCategory["TourEntryLeadForm"] = "tourEntryLeadForm";
    LeadCategory["InTourLeadImage"] = "inTourLeadImage";
    LeadCategory["TourContactForm"] = "tourContactForm";
    LeadCategory["AssertTouchForm"] = "assertTouchForm";
})(LeadCategory || (LeadCategory = {}));


/***/ }),

/***/ 75293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var SidebarHr = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
        style: {
            border: "1px solid #ffffff29",
            width: "80%",
            margin: "auto"
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SidebarHr);


/***/ }),

/***/ 96858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Icon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62097);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61225);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61953);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





function Icon(param) {
    var icon = param.icon, _style = param.style, style = _style === void 0 ? "far" : _style, _size = param.size, size = _size === void 0 ? "medium" : _size, onClick = param.onClick, sx = param.sx;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var isMobile = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(theme.breakpoints.down("sm"));
    // Logic for responsive icon font size. Will be finished later
    var fontSize = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (size === "large") {
            return isMobile ? "20px" : "30px";
        }
        if (size === "medium") {
            return isMobile ? "20px" : "20px";
        }
        return "15px";
    }, [
        size,
        isMobile
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        onClick: onClick,
        component: "i",
        className: "".concat(style, " ").concat(icon, " fa-fw"),
        sx: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, sx), {
            fontSize: "".concat(fontSize, " !important"),
            color: theme.palette.common.white
        })
    });
}


/***/ }),

/***/ 75643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "JO": function() { return /* reexport */ Icon/* default */.Z; },
  "Ee": function() { return /* reexport */ Image; },
  "lE": function() { return /* reexport */ MapResponsive; },
  "h2": function() { return /* reexport */ ResponsiveContainer; }
});

// UNUSED EXPORTS: MenuWithSidebarState, SidebarHr

// EXTERNAL MODULE: ./components-new/common/icon/Icon.tsx
var Icon = __webpack_require__(96858);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./utils/getRatio.ts
var getRatio = __webpack_require__(19245);
;// CONCATENATED MODULE: ./components-new/common/MapResponsive.tsx



function MapResponsive(param) {
    var ratio = param.ratio, address = param.address;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        component: "span",
        sx: {
            width: 1,
            lineHeight: 1,
            display: "block",
            overflow: "hidden",
            position: "relative",
            borderRadius: "5px",
            pt: (0,getRatio/* default */.Z)(ratio),
            "& .wrapper": {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                lineHeight: 0,
                position: "absolute",
                backgroundSize: "cover !important"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: "wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                src: "https://www.google.com/maps/embed/v1/place?key=".concat("AIzaSyAxJYg1iR0WMy4vpFa3zB7E0Dx7lz8h5dk", "&q=").concat(address),
                style: {
                    width: "100%",
                    height: "100%"
                },
                loading: "lazy"
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(72679);
;// CONCATENATED MODULE: ./components-new/common/Image.tsx






function Image(_param) {
    var ratio = _param.ratio, _disabledEffect = _param.disabledEffect, disabledEffect = _disabledEffect === void 0 ? false : _disabledEffect, _effect = _param.effect, effect = _effect === void 0 ? "blur" : _effect, objectFit = _param.objectFit, overComponent = _param.overComponent, sx = _param.sx, other = (0,_object_without_properties/* default */.Z)(_param, [
        "ratio",
        "disabledEffect",
        "effect",
        "objectFit",
        "overComponent",
        "sx"
    ]);
    var imageComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,src_object_spread/* default */.Z)({
        component: build.LazyLoadImage,
        wrapperClassName: "wrapper",
        effect: disabledEffect ? undefined : effect,
        placeholderSrc: "https://zone-assets-api.vercel.app/assets/img_placeholder.svg",
        sx: {
            width: 1,
            height: 1,
            objectFit: objectFit
        }
    }, other));
    if (ratio) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            component: "span",
            sx: (0,src_object_spread/* default */.Z)({
                width: 1,
                lineHeight: 1,
                display: "block",
                overflow: "hidden",
                position: "relative",
                pt: (0,getRatio/* default */.Z)(ratio),
                "& .wrapper": {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    lineHeight: 0,
                    position: "absolute",
                    backgroundSize: "cover !important"
                }
            }, sx),
            children: [
                imageComponent,
                overComponent
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        component: "span",
        sx: (0,src_object_spread/* default */.Z)({
            lineHeight: 0,
            display: "block",
            overflow: "hidden",
            "& .wrapper": {
                width: 1,
                height: 1,
                backgroundSize: "cover !important"
            }
        }, sx),
        children: imageComponent
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(23926);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Stack/Stack.js
var Stack = __webpack_require__(9144);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@treedis/tour-loader/dist/index.js + 153 modules
var dist = __webpack_require__(33050);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
// EXTERNAL MODULE: ./_models/Tour.tsx + 1 modules
var Tour = __webpack_require__(40784);
// EXTERNAL MODULE: ./_models/Menu.tsx
var _models_Menu = __webpack_require__(78073);
// EXTERNAL MODULE: ./components/util/analytic.ts + 2 modules
var analytic = __webpack_require__(44000);
// EXTERNAL MODULE: ./components/util/deviceManager.ts
var deviceManager = __webpack_require__(99080);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
;// CONCATENATED MODULE: ./components/tour/regular/menu/components/styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &::-webkit-scrollbar-thumb {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  background: ",
        ";\n  &:hover {\n    background: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var UlStyled = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "styled__UlStyled",
    componentId: "sc-31766a56-0"
})(_templateObject(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.scrollbarColor) ? "".concat(props === null || props === void 0 ? void 0 : props.scrollbarColor, "!important") : "var(--color-secondary)";
});
var LiStyled = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "styled__LiStyled",
    componentId: "sc-31766a56-1"
})(_templateObject1(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.isActive) ? "var(--color-secondary) !important" : (props === null || props === void 0 ? void 0 : props.textColor) && "".concat(props === null || props === void 0 ? void 0 : props.textColor, "!important");
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.isActive) && (props === null || props === void 0 ? void 0 : props.bgColor) ? "".concat(props === null || props === void 0 ? void 0 : props.bgColor, "!important") : (props === null || props === void 0 ? void 0 : props.openedColor) && "".concat(props === null || props === void 0 ? void 0 : props.openedColor, "!important");
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.bgColor) ? "".concat(props === null || props === void 0 ? void 0 : props.bgColor, "!important") : (props === null || props === void 0 ? void 0 : props.openedColor) && "".concat(props === null || props === void 0 ? void 0 : props.openedColor, "!important");
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.textColor) ? "".concat(props === null || props === void 0 ? void 0 : props.textColor, "!important") : "var(--color-secondary) !important";
});

// EXTERNAL MODULE: ./components/util/index.ts + 7 modules
var util = __webpack_require__(97666);
;// CONCATENATED MODULE: ./components/tour/regular/menu/components/LeftMenuNav.tsx







function LeftMenuNav(props) {
    var menus = props.menus, openMenu = props.openMenu, loadModel = props.loadModel, menuSettings = props.menuSettings, menuOpen = props.menuOpen, currentSweep = props.currentSweep, deprecatedSweeps = props.deprecatedSweeps, resetMenus = props.resetMenus;
    var openedMenu = menus ? menus.find(function(m) {
        return m.open;
    }) : null;
    var subMenus = openedMenu ? openedMenu === null || openedMenu === void 0 ? void 0 : openedMenu.subMenus : null;
    var openedSubMenus = subMenus ? subMenus.find(function(sm) {
        return sm === null || sm === void 0 ? void 0 : sm.open;
    }) : null;
    var subSubMenus = openedSubMenus ? openedSubMenus === null || openedSubMenus === void 0 ? void 0 : openedSubMenus.subSubMenus : null;
    (0,react.useEffect)(function() {
        var updatedMenus = menus === null || menus === void 0 ? void 0 : menus.map(function(menu) {
            var ref;
            var ss = +(0,util/* getQueryVariable */.Dv)(menu.url, "ss");
            var scanId = ss > 0 && (deprecatedSweeps === null || deprecatedSweeps === void 0 ? void 0 : deprecatedSweeps.length) > 0 ? deprecatedSweeps[ss - 1].sweep_uuid.replace(/-/g, "") : null;
            var updatedSubMenus = (ref = menu.subMenus) === null || ref === void 0 ? void 0 : ref.map(function(subMenu) {
                var ref;
                var subMenuId = subMenu.type === _models_Menu/* MenuType.Treedis */.o.Treedis ? (0,util/* getQueryVariable */.Dv)(subMenu.url, "s") : null;
                if ((subMenuId === (currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.id) || scanId === (currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.id)) && subMenu.shouldHighlight) {
                    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, subMenu), {
                        visited: true
                    });
                }
                var updatedSubSubMenus = (ref = subMenu.subSubMenus) === null || ref === void 0 ? void 0 : ref.map(function(subSubMenu) {
                    var subSubMenuId = subSubMenu.type === _models_Menu/* MenuType.Treedis */.o.Treedis ? (0,util/* getQueryVariable */.Dv)(subSubMenu.url, "s") : null;
                    if ((subSubMenuId === (currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.id) || scanId === (currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.id)) && subSubMenu.shouldHighlight) {
                        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, subSubMenu), {
                            visited: true
                        });
                    }
                    return subSubMenu;
                });
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, subMenu), {
                    subSubMenus: updatedSubSubMenus
                });
            });
            var menuId = menu.type === _models_Menu/* MenuType.Treedis */.o.Treedis ? (0,util/* getQueryVariable */.Dv)(menu.url, "s") : null;
            if ((menuId === (currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.id) || scanId === (currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.id)) && menu.shouldHighlight) {
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, menu), {
                    visited: true
                });
            }
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, menu), {
                subMenus: updatedSubMenus
            });
        });
        resetMenus(updatedMenus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.id
    ]);
    var handleOpenMenuItem = function(menuItem, menuIndex, subMenuIndex) {
        var i;
        var j = null;
        if (menuIndex === null) {
            i = menus.findIndex(function(m) {
                return m.id === menuItem.menuId;
            });
        } else {
            i = menuIndex;
        }
        if (subMenuIndex !== null) {
            j = subMenuIndex;
        }
        openMenu(i, j);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "left-menu",
        className: "container",
        children: [
            menuOpen && subSubMenus && subSubMenus.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                className: "subSubMenus"
            }, (menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuBgColor) && {
                style: {
                    backgroundColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuBgColor
                }
            }), {
                children: subSubMenus.map(function(subSubMenu, i) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(LiStyled, {
                        onClick: function() {
                            loadModel(subSubMenu);
                            (0,util/* sendToGA */.o$)("event", {
                                eventCategory: "Place",
                                eventAction: "click",
                                eventLabel: subSubMenu.title,
                                eventType: subSubMenu.type
                            });
                        },
                        className: "loadModel",
                        bgColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuActiveColor,
                        textColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuTxtColor,
                        isActive: subSubMenu.visited,
                        children: subSubMenu.title
                    }, i);
                })
            })),
            menuOpen && subMenus && subMenus.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                className: "subMenus"
            }, (menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuBgColor) && {
                style: {
                    backgroundColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuBgColor
                }
            }), {
                children: subMenus.map(function(subMenu, i) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(LiStyled, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        className: "mainLink ".concat(subMenu.open ? "open" : ""),
                        bgColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuActiveColor,
                        textColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuTxtColor,
                        isActive: subMenu.visited
                    }, subMenu.open && i === 0 && {
                        openedColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.openedMenuColor
                    }), {
                        onClick: function() {
                            if (subMenu.subSubMenus.length > 0) {
                                handleOpenMenuItem(subMenu, null, i);
                            } else {
                                loadModel(subMenu);
                                (0,util/* sendToGA */.o$)("event", {
                                    eventCategory: "Place",
                                    eventAction: "click",
                                    eventLabel: subMenu.title,
                                    eventType: subMenu.type
                                });
                            }
                        },
                        children: [
                            subMenu.title,
                            subMenu.subSubMenus && subMenu.subSubMenus.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-caret-down"
                            })
                        ]
                    }), i);
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "menus",
                children: !menus ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}) : menus.map(function(menu, i) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(LiStyled, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        className: "mainLink ".concat(menus[i].open ? "open" : ""),
                        bgColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuActiveColor,
                        textColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuTxtColor,
                        isActive: menu.visited
                    }, menus[i].open && i === 0 && {
                        openedColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.openedMenuColor
                    }), {
                        onClick: function() {
                            if (menu.subMenus.length > 0) {
                                handleOpenMenuItem(menu, i, null);
                            } else {
                                loadModel(menu);
                                (0,util/* sendToGA */.o$)("event", {
                                    eventCategory: "Place",
                                    eventAction: "click",
                                    eventLabel: menu.title,
                                    eventType: menu.type
                                });
                            }
                        },
                        children: [
                            menu.title,
                            menu.subMenus && menu.subMenus.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-caret-down"
                            })
                        ]
                    }), i);
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/tour/regular/menu/components/MenuNav.tsx







function MenuNav(props) {
    var menus = props.menus, openMenu = props.openMenu, loadModel = props.loadModel, rtl = props.rtl, menuRef = props.menuRef, menuSettings = props.menuSettings, resetMenus = props.resetMenus, currentSweep = props.currentSweep, deprecatedSweeps = props.deprecatedSweeps;
    var disableActive = function() {
        var newMenus = menus === null || menus === void 0 ? void 0 : menus.map(function(menu) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, menu), {
                isActive: false,
                subMenus: menu === null || menu === void 0 ? void 0 : menu.subMenus.map(function(subMenu) {
                    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, subMenu), {
                        isActive: false
                    });
                })
            });
        });
        resetMenus(newMenus);
    };
    (0,react.useEffect)(function() {
        var updatedMenus = menus === null || menus === void 0 ? void 0 : menus.map(function(menu) {
            var ref;
            var ss = +(0,util/* getQueryVariable */.Dv)(menu.url, "ss");
            var scanId = ss > 0 && (deprecatedSweeps === null || deprecatedSweeps === void 0 ? void 0 : deprecatedSweeps.length) > 0 ? deprecatedSweeps[ss - 1].sweep_uuid.replace(/-/g, "") : null;
            var updatedSubMenus = (ref = menu.subMenus) === null || ref === void 0 ? void 0 : ref.map(function(subMenu) {
                var ref;
                var subMenuId = subMenu.type === _models_Menu/* MenuType.Treedis */.o.Treedis ? (0,util/* getQueryVariable */.Dv)(subMenu.url, "s") : null;
                if ((subMenuId === (currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.id) || scanId === (currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.id)) && subMenu.shouldHighlight) {
                    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, subMenu), {
                        visited: true
                    });
                }
                var updatedSubSubMenus = (ref = subMenu.subSubMenus) === null || ref === void 0 ? void 0 : ref.map(function(subSubMenu) {
                    var subSubMenuId = subSubMenu.type === _models_Menu/* MenuType.Treedis */.o.Treedis ? (0,util/* getQueryVariable */.Dv)(subSubMenu.url, "s") : null;
                    if ((subSubMenuId === (currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.id) || scanId === (currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.id)) && subSubMenu.shouldHighlight) {
                        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, subSubMenu), {
                            visited: true
                        });
                    }
                    return subSubMenu;
                });
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, subMenu), {
                    subSubMenus: updatedSubSubMenus
                });
            });
            var menuId = menu.type === _models_Menu/* MenuType.Treedis */.o.Treedis ? (0,util/* getQueryVariable */.Dv)(menu.url, "s") : null;
            if ((menuId === (currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.id) || scanId === (currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.id)) && menu.shouldHighlight) {
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, menu), {
                    visited: true
                });
            }
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, menu), {
                subMenus: updatedSubMenus
            });
        });
        resetMenus(updatedMenus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UlStyled, {
        id: "menu",
        className: rtl ? "rtl" : "",
        ref: menuRef,
        scrollbarColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.scrollbarColor,
        children: menus && menus.map(function(menu, i) {
            return menu.subMenus && menu.subMenus.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "sublinks-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LiStyled, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        className: "mainLink ".concat(menus[i].open ? "open" : ""),
                        onClick: function() {
                            return openMenu(i, null);
                        },
                        bgColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuActiveColor,
                        textColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuTxtColor,
                        isActive: menu.visited
                    }, menus[i].open && {
                        openedColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.openedMenuColor
                    }), {
                        children: [
                            menu.title,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-caret-down"
                            })
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "sublinks ".concat(menus[i].open ? "open" : "closed"),
                        children: menu.subMenus.map(function(subMenu, j) {
                            return subMenu.subSubMenus && subMenu.subSubMenus.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "sub_sublinks-container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LiStyled, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                        className: "mainLink ".concat(menus[i].subMenus[j].open ? "open" : ""),
                                        onClick: function() {
                                            return openMenu(i, j);
                                        },
                                        bgColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuActiveColor,
                                        textColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuTxtColor,
                                        isActive: subMenu.visited
                                    }, menus[i].subMenus[j].open && {
                                        openedColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.openedMenuColor
                                    }), {
                                        children: [
                                            subMenu.title,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fas fa-caret-down"
                                            })
                                        ]
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "sub_sublinks ".concat(menus[i].subMenus[j].open ? "open" : "closed"),
                                        children: subMenu.subSubMenus.map(function(subSubMenu, x) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(LiStyled, {
                                                onClick: function() {
                                                    console.log(1);
                                                    loadModel(subSubMenu);
                                                    (0,util/* sendToGA */.o$)("event", {
                                                        eventCategory: "Place",
                                                        eventAction: "click",
                                                        eventLabel: subSubMenu.title,
                                                        eventType: subSubMenu.type
                                                    });
                                                },
                                                className: "loadModel",
                                                bgColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuActiveColor,
                                                textColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuTxtColor,
                                                isActive: subSubMenu.visited || subSubMenu.isActive,
                                                children: subSubMenu.title
                                            }, x);
                                        })
                                    })
                                ]
                            }, j) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LiStyled, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                onClick: function() {
                                    console.log(2);
                                    loadModel(subMenu);
                                    (0,util/* sendToGA */.o$)("event", {
                                        eventCategory: "Place",
                                        eventAction: "click",
                                        eventLabel: subMenu.title,
                                        eventType: subMenu.type
                                    });
                                },
                                className: "loadModel",
                                bgColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuActiveColor,
                                textColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuTxtColor,
                                isActive: subMenu.visited || subMenu.isActive
                            }, subMenu.isActive && {
                                onMouseEnter: disableActive
                            }), {
                                children: subMenu.title
                            }), j);
                        })
                    })
                ]
            }, i) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LiStyled, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                onClick: function() {
                    loadModel(menu);
                    (0,util/* sendToGA */.o$)("event", {
                        eventCategory: "Place",
                        eventAction: "click",
                        eventLabel: menu.title,
                        eventType: menu.type
                    });
                }
            }, menu.isActive && {
                onMouseEnter: disableActive
            }), {
                className: "loadModel",
                isActive: menu.visited || menu.isActive,
                bgColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuActiveColor,
                textColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuTxtColor,
                children: menu.title
            }), i);
        })
    });
}

// EXTERNAL MODULE: ./components/tour/regular/menu/menuService.ts
var menuService = __webpack_require__(45019);
;// CONCATENATED MODULE: ./components/tour/regular/menu/styled.tsx

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  &.insideEcommerce {\n    top: 85px !important;\n    border-radius: 8px !important;\n  }\n  &.openWithSidebar {\n    right: 50px !important;\n  }\n  &.openWithSidebarMax {\n    right: 180px !important;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var BookStyled = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "styled__BookStyled",
    componentId: "sc-3a0ffaf3-0"
})(styled_templateObject(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.color) && "".concat(props.color, "!important");
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.textColor) && "".concat(props.textColor, "!important");
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.hoverColor) ? "".concat(props.hoverColor, "!important") : "var(--color-secondary)!important";
});
var SearchSpanStyled = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styled__SearchSpanStyled",
    componentId: "sc-3a0ffaf3-1"
})(styled_templateObject1(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.color) && "".concat(props.color, "!important");
});
var NavStyled = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    displayName: "styled__NavStyled",
    componentId: "sc-3a0ffaf3-2"
})(_templateObject2(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.menuBgColor) ? "".concat(props === null || props === void 0 ? void 0 : props.menuBgColor, " !important") : "";
});
var DivStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__DivStyled",
    componentId: "sc-3a0ffaf3-3"
})(_templateObject3(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.color) && "".concat(props.color, "!important");
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.textColor) && "".concat(props.textColor, "!important");
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.hoverColor) ? "".concat(props.hoverColor, "!important") : "var(--color-secondary)!important";
});

;// CONCATENATED MODULE: ./components/tour/regular/menu/Menu.tsx





















var Menu_Menu = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Menu, Component);
    var _super = (0,_create_super/* default */.Z)(Menu);
    function Menu(props) {
        (0,_class_call_check/* default */.Z)(this, Menu);
        var _this;
        _this = _super.call(this, props);
        _this.handleClickAway = function(ev) {
            var ref, ref1, ref2, ref3, ref4;
            if (_this.props.isEcommerce && typeof ((ref = ev.target) === null || ref === void 0 ? void 0 : (ref1 = ref.className) === null || ref1 === void 0 ? void 0 : ref1.includes) === "function" && !((ref2 = ev.target) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.className) === null || ref3 === void 0 ? void 0 : ref3.includes("sb-openMenu")) && !((ref4 = ev.target) === null || ref4 === void 0 ? void 0 : ref4.querySelector(".sb-openMenu"))) {
                _this.props.onClose();
            }
        };
        _this.handleMouseLeave = function() {
            _this.closeMenu();
        };
        _this.state = {
            menus: _this.props.menus || [],
            menuSettings: _this.props.menuSettings,
            originMenus: [],
            tourId: _this.props.tourId,
            menuOpen: _this.props.menuOpen,
            menuSearch: _this.props.menuSearch,
            bookUrl: _this.props.bookUrl,
            bookText: _this.props.bookText,
            bookColor: _this.props.bookColor,
            contact: _this.props.contact,
            bookAppointment: _this.props.bookAppointment,
            whitelabel: _this.props.whitelabel,
            address: _this.props.address,
            rtl: _this.props.client && _this.props.client.rtl,
            activeMenu: _this.props.activeMenu,
            scrollTo: 0,
            currentSweep: _this.props.currentSweep,
            deprecatedSweeps: _this.props.deprecatedSweeps
        };
        _this.moveToMenuItem = _this.moveToMenuItem.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.toggleContactPopup = props.toggleContactPopup.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.toggleExternalPopup = props.toggleExternalPopup.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.closeMenu = props.closeMenu.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.openMenu = _this.openMenu.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.inputSearch = /*#__PURE__*/ (0,react.createRef)();
        return _this;
    }
    var _proto = Menu.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var _props, menuCategoryExpand, menus;
            return (0,tslib_es6.__generator)(this, function(_state) {
                _props = _this.props, menuCategoryExpand = _props.menuCategoryExpand, menus = _props.menus;
                if (menuCategoryExpand) {
                    menus.forEach(function(menu) {
                        menu.open = !menu.open;
                    });
                }
                _this.setState({
                    menus: menus,
                    originMenus: cloneDeep_default()(menus)
                });
                return [
                    2
                ];
            });
        })();
    };
    _proto.openMenu = function openMenu(i) {
        var j = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        var scrollTo = (i + 1) * 33;
        var menus = this.state.menus;
        var menu = menus[i];
        if (!menu) {
            Menu.resetMenus(menus);
            return;
        }
        if (j != null) {
            menu = menu.subMenus[j];
            scrollTo += (j + 1) * 33;
        }
        // commenting this part out because this is not closing the opened nested menus, only opens them
        // if (Menu.isHorizontalMobileView()) {
        //   Menu.resetMenus(menus);
        //   if (menu.subMenuId) {
        //     const parent = menus.subMenus.find(({ id }) => id === menu.subMenuId);
        //     if (parent) parent.open = !parent.open;
        //   }
        //   if (menu.menuId) {
        //     const parent = menus.find(({ id }) => id === menu.menuId);
        //     if (parent) parent.open = !parent.open;
        //   }
        // }
        menu.open = !menu.open;
        this.setState({
            menus: menus,
            scrollTo: scrollTo
        });
        if (menu.title) {
            (0,analytic/* sendToGA */.o$)("event", {
                eventCategory: "Place",
                eventAction: "click",
                eventLabel: menu.title,
                eventType: menu.type
            });
        }
    };
    _proto.moveToMenuItem = function moveToMenuItem(menu) {
        var _props = this.props, moveToMPLabels = _props.moveToMPLabels, loadModel = _props.loadModel;
        if (menu.type === _models_Menu/* MenuType.MatterportLabel */.o.MatterportLabel || menu.type === _models_Menu/* MenuType.MatterportFloor */.o.MatterportFloor) {
            moveToMPLabels(menu);
        } else {
            loadModel(menu.title, menu.url, menu.type, menu.tag, menu.panoramaId, menu.changeMinimap, menu.changePanorama, menu.iframeSettings, menu.changeReel);
        }
        if (Menu.isHorizontalMobileView()) {
            Menu.resetMenus(this.state.menus);
        }
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, menus, menuSettings;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (_this.state.menuOpen && _this.menu && _this.state.activeMenu) {
                            _this.menu.scrollTop = _this.state.scrollTo - 33;
                        }
                        if (!(_this.props.changeMenu && _this.props.changeMenu !== prevProps.changeMenu)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,menuService/* fetchMenuData */.g)(_this.props.tourId)
                        ];
                    case 1:
                        ref = _state.sent(), menus = ref.menus, menuSettings = ref.menuSettings;
                        // eslint-disable-next-line react/no-did-update-set-state
                        _this.setState({
                            menus: menus,
                            menuSettings: menuSettings,
                            originMenus: cloneDeep_default()(menus)
                        });
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.onChangeSearch = function onChangeSearch(param) {
        var target = param.target;
        var searchStr = target.value.toLowerCase();
        this.setState({
            menus: (0,dist/* filterMenuItems */.j4)(this.state.originMenus, searchStr)
        });
    };
    _proto.getOpenClassName = function getOpenClassName() {
        var _props = this.props, sbIsOpen = _props.sbIsOpen, tourType = _props.tourType;
        if (tourType === Tour/* TourType.ECommerce */.v.ECommerce) {
            if (sbIsOpen) {
                return "openWithSidebarMax";
            }
            return "openWithSidebar";
        }
        return "open";
    };
    _proto.render = function render() {
        var _this = this;
        var _state = this.state, rtl = _state.rtl, menuOpen = _state.menuOpen, whitelabel = _state.whitelabel, menuSettings = _state.menuSettings, bookColor = _state.bookColor, currentSweep = _state.currentSweep, deprecatedSweeps = _state.deprecatedSweeps;
        var isRegularTour = this.props.tourType === Tour/* TourType.Regular */.v.Regular;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
            mouseEvent: "onMouseUp",
            onClickAway: this.handleClickAway,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavStyled, {
                // openOnHover is currently implemented only for Regular tours
                onMouseLeave: (menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.openOnHover) && isRegularTour ? this.handleMouseLeave : null,
                className: classnames_default()(this.props.tourType === Tour/* TourType.ECommerce */.v.ECommerce && "insideEcommerce", menuOpen && this.getOpenClassName(), rtl && "rtl", deviceManager/* default.isHorizontalMobileView */.Z.isHorizontalMobileView() && "horizontal-modile-menu-view"),
                menuBgColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuBgColor,
                children: [
                    this.state.bookUrl && this.state.bookText && /*#__PURE__*/ (0,jsx_runtime.jsx)(BookStyled, {
                        color: bookColor,
                        hoverColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.bookActiveColor,
                        textColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.bookTxtColor,
                        onClick: function() {
                            (0,analytic/* sendToGA */.o$)("event", {
                                eventCategory: "Book Now",
                                eventAction: "click"
                            });
                        },
                        id: "book",
                        rel: "noreferrer",
                        target: "_blank",
                        href: this.state.bookUrl,
                        children: this.state.bookText
                    }),
                    this.state.menuSearch && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("menu-search-container", rtl && "rtl"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                className: "form-control",
                                onChange: this.onChangeSearch.bind(this),
                                placeholder: this.props.translation && this.props.translation.searchMenu || "Search...",
                                ref: this.inputSearch
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-times",
                                onClick: function() {
                                    _this.onChangeSearch({
                                        target: {
                                            value: ""
                                        }
                                    });
                                    _this.inputSearch.current.value = "";
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchSpanStyled, {
                                className: "input-group-text",
                                color: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.searchButtonColor,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fas fa-search"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        sx: {
                            color: "#fff"
                        },
                        px: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h6",
                            children: this.props.translation && this.props.translation.menu
                        })
                    }),
                    Menu.isHorizontalMobileView() && /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftMenuNav, {
                        menus: this.state.menus,
                        menuSettings: menuSettings,
                        openMenu: this.openMenu,
                        loadModel: this.moveToMenuItem,
                        menuOpen: menuOpen,
                        menuRef: function(el) {
                            _this.menu = el;
                        },
                        resetMenus: function(menus) {
                            return _this.setState({
                                menus: menus
                            });
                        },
                        currentSweep: currentSweep,
                        deprecatedSweeps: deprecatedSweeps
                    }),
                    !Menu.isHorizontalMobileView() && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuNav, {
                        menus: this.state.menus,
                        menuSettings: menuSettings,
                        rtl: rtl,
                        openMenu: this.openMenu,
                        loadModel: this.moveToMenuItem,
                        resetMenus: function(menus) {
                            return _this.setState({
                                menus: menus
                            });
                        },
                        menuRef: function(el) {
                            _this.menu = el;
                        },
                        currentSweep: currentSweep,
                        deprecatedSweeps: deprecatedSweeps
                    }),
                    this.state.bookAppointment && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "appointmentButton",
                        onClick: this.props.toggleAppointmentsModal,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "far fa-calendar-alt"
                            }),
                            this.props.translation && this.props.translation.bookAppointment
                        ]
                    }),
                    this.state.contact && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DivStyled, {
                        color: bookColor,
                        hoverColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.bookActiveColor,
                        textColor: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.bookTxtColor,
                        className: "contactButton",
                        onClick: this.props.toggleContactPopup,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fas fa-mobile"
                            }),
                            " ",
                            this.props.translation && this.props.translation.getInTouch
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: rtl ? "rtl contact" : "contact",
                        children: [
                            this.state.address && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                onClick: function() {
                                    _this.toggleExternalPopup(_this.state.tourId === 5238 // This is magic number, TODO: create a feature out of this. quick fix.
                                     ? "https://www.skoda.co.il/show-rooms" : "https://www.google.com/maps/embed/v1/place?key=AIzaSyAxJYg1iR0WMy4vpFa3zB7E0Dx7lz8h5dk&q=".concat(_this.state.address));
                                    (0,analytic/* sendToGA */.o$)("event", {
                                        eventCategory: "Contact",
                                        eventAction: "click",
                                        eventLabel: "map"
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fas fa-map-marker-alt"
                                    }),
                                    this.state.address
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                children: [
                                    this.props.translation && this.props.translation.producedBy,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        rel: "noreferrer",
                                        target: "_blank",
                                        href: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.website,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.logo,
                                            alt: ""
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    };
    Menu.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        var scrollTo = prevState.scrollTo;
        if (!nextProps.menuOpen) scrollTo = 0;
        if (nextProps.menuOpen !== prevState.menuOpen) {
            var menus = prevState.menus;
            var activeMenu = nextProps.activeMenu;
            if (activeMenu) {
                if (!prevState.activeMenu || activeMenu.id !== prevState.activeMenu.id || activeMenu.subMenu !== prevState.activeMenu.subMenu || activeMenu.subSubMenu !== prevState.activeMenu.subSubMenu) {
                    if (activeMenu.id) {
                        var i = menus.findIndex(function(m) {
                            return m.id === activeMenu.id;
                        });
                        if (i >= 0) {
                            menus[i].open = true;
                            menus[i].isActive = true;
                            scrollTo = (i + 1) * 33;
                            if (activeMenu.subMenu) {
                                var j = menus[i].subMenus.findIndex(function(m) {
                                    return m.id === activeMenu.subMenu;
                                });
                                if (j >= 0) {
                                    menus[i].subMenus[j].open = true;
                                    menus[i].subMenus[j].isActive = true;
                                    scrollTo += (j + 1) * 33;
                                } else {
                                    react_toastify_esm/* toast.error */.Am.error("Menu item does not exist");
                                }
                            } else {
                                Menu.resetMenus(menus[i].subMenus);
                            }
                        } else {
                            react_toastify_esm/* toast.error */.Am.error("Menu item does not exist");
                        }
                    } else {
                        Menu.resetMenus(menus);
                    }
                }
            } else if (Menu.isHorizontalMobileView() && !nextProps.menuOpen) {
                Menu.resetMenus(menus);
            }
            return {
                menuOpen: nextProps.menuOpen,
                menus: menus,
                activeMenu: activeMenu,
                scrollTo: scrollTo,
                contact: nextProps.contact
            };
        }
        return {
            scrollTo: scrollTo
        };
    };
    Menu.resetMenus = function resetMenus(menus) {
        menus.map(function(m) {
            m.open = false;
            if (m.subMenus) {
                m.subMenus = m.subMenus.map(function(sM) {
                    sM.open = false;
                    return sM;
                });
            }
            return m;
        });
    };
    Menu.isHorizontalMobileView = function isHorizontalMobileView() {
        return deviceManager/* default.isHorizontalMobileView */.Z.isHorizontalMobileView();
    };
    return Menu;
}(react.Component);


// EXTERNAL MODULE: ./store/index.ts + 7 modules
var store = __webpack_require__(12781);
;// CONCATENATED MODULE: ./components-new/common/MenuWithSidebarState.tsx





var MenuWithSidebarState = function(props) {
    var sbIsOpen = useRecoilValue(sidebarOpenState);
    return /*#__PURE__*/ _jsx(Menu, _object_spread_props(_object_spread({}, props), {
        sbIsOpen: sbIsOpen
    }));
};
/* harmony default export */ var common_MenuWithSidebarState = ((/* unused pure expression or super */ null && (MenuWithSidebarState)));

;// CONCATENATED MODULE: ./components-new/common/ResponsiveContainer.tsx






function ResponsiveContainer(_param) {
    var _ratio = _param.ratio, ratio = _ratio === void 0 ? "1/1" : _ratio, containerStyles = _param.containerStyles, children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "ratio",
        "containerStyles",
        "children"
    ]);
    return ratio === "cover" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        position: "relative",
        sx: {
            paddingTop: "100vh"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
                position: "absolute",
                top: "43px",
                left: "-16px",
                width: "100vw",
                height: "calc(100vh - 59px)"
            },
            children: children
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        component: "span",
        sx: (0,src_object_spread/* default */.Z)({
            width: 1,
            lineHeight: 1,
            display: "block",
            overflow: "hidden",
            position: "relative",
            pt: (0,getRatio/* default */.Z)(ratio),
            "& .wrapper": {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                lineHeight: 0,
                position: "absolute",
                backgroundSize: "cover !important"
            }
        }, containerStyles),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            className: "wrapper",
            sx: {
                width: 1,
                height: 1
            }
        }, other), {
            children: children
        }))
    });
}

// EXTERNAL MODULE: ./components-new/common/SidebarHr.tsx
var SidebarHr = __webpack_require__(75293);
;// CONCATENATED MODULE: ./components-new/index.ts









/***/ }),

/***/ 45019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ fetchMenuData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20414);
/* harmony import */ var _util_all__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40488);



var fetchMenuData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(tourId) {
        var ref, menus, menuSettings, productTypes, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _util_all__WEBPACK_IMPORTED_MODULE_0__/* .fetchData */ .rQ("public/getMenu", "POST", {
                            id: tourId
                        })
                    ];
                case 1:
                    ref = _state.sent(), menus = ref.menus, menuSettings = ref.menuSettings, productTypes = ref.productTypes;
                    return [
                        2,
                        {
                            menus: menus,
                            menuSettings: menuSettings,
                            productTypes: (productTypes || []).filter(function(type) {
                                return type.countProducts > 0;
                            })
                        }
                    ];
                case 2:
                    err = _state.sent();
                    console.error(err.message);
                    return [
                        2,
                        []
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchMenuData(tourId) {
        return _ref.apply(this, arguments);
    };
}();



/***/ }),

/***/ 12978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ units_Iframe; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(22004);
;// CONCATENATED MODULE: ./units/Iframe/IframeStyledHOC.tsx




var IframeStyledHOC = function(_param) {
    var onLoad = _param.onLoad, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "onLoad"
    ]);
    var playerRef = (0,react.useRef)();
    var getPlayerInstanceAndTryToPlay = function() {
        try {
            if (rest.autoplay) {
                var ref;
                // youtube autoplay fix
                var ytPlayer = (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.getInternalPlayer();
                if (typeof (ytPlayer === null || ytPlayer === void 0 ? void 0 : ytPlayer.playVideo) === "function") {
                    ytPlayer === null || ytPlayer === void 0 ? void 0 : ytPlayer.playVideo();
                }
            }
            onLoad();
        } catch (err) {
            console.error(err);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
        width: "100%",
        height: "100%",
        controls: true,
        url: rest.url,
        onReady: getPlayerInstanceAndTryToPlay,
        playing: rest.autoplay,
        muted: rest.mute,
        ref: playerRef
    });
};
/* harmony default export */ var Iframe_IframeStyledHOC = (/*#__PURE__*/(0,react.memo)(IframeStyledHOC));

// EXTERNAL MODULE: ./units/Iframe/style.tsx
var style = __webpack_require__(54811);
;// CONCATENATED MODULE: ./units/Iframe/index.tsx






var Iframe = function(_param) {
    var src = _param.src, logoSrc = _param.logoSrc, useModernPlayer = _param.useModernPlayer, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "logoSrc",
        "useModernPlayer"
    ]);
    var ref = (0,react.useState)(true), loading = ref[0], setLoading = ref[1];
    var hideSpinner = function() {
        setLoading(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* Root */.fC, {
        children: [
            loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* Loader */.aN, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* Spinner */.$j, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* Logo */.TR, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: logoSrc,
                            alt: ""
                        })
                    })
                ]
            }),
            useModernPlayer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Iframe_IframeStyledHOC, (0,_object_spread/* default */.Z)({
                width: "100%",
                height: "100%",
                src: src,
                onLoad: hideSpinner
            }, rest)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* IframeStyled */.C, (0,_object_spread/* default */.Z)({
                width: "100%",
                height: "100%",
                src: src,
                allow: "geolocation;camera;microphone",
                onLoad: hideSpinner
            }, rest))
        ]
    });
};
/* harmony default export */ var units_Iframe = (Iframe);


/***/ }),

/***/ 54811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$j": function() { return /* binding */ Spinner; },
/* harmony export */   "C": function() { return /* binding */ IframeStyled; },
/* harmony export */   "TR": function() { return /* binding */ Logo; },
/* harmony export */   "aN": function() { return /* binding */ Loader; },
/* harmony export */   "fC": function() { return /* binding */ Root; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18533);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100% !important;\n  height: 100% !important;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  pointer-events: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 115px;\n  height: 115px;\n  object-fit: contain;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n\n  & img {\n    object-fit: contain;\n    height: 100%;\n    width: 100%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 150px;\n  min-height: 150px;\n  width: 150px;\n  height: 150px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n\n  &::after {\n    content: ' ';\n    display: block;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    position: absolute;\n    border-radius: 50%;\n    border: 3px solid #fff;\n    border-color: var(--color-secondary) transparent var(--color-secondary) transparent;\n    animation: ",
        " 1.2s linear infinite;\n    top: 0;\n    left: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  html body img {\n    height: 100%;\n    width: 100%;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var spinner = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject());
var Root = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__Root",
    componentId: "sc-5c3f9880-0"
})(_templateObject1());
var Loader = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__Loader",
    componentId: "sc-5c3f9880-1"
})(_templateObject2());
var Logo = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__Logo",
    componentId: "sc-5c3f9880-2"
})(_templateObject3());
var Spinner = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__Spinner",
    componentId: "sc-5c3f9880-3"
})(_templateObject4(), spinner);
var IframeStyled = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].iframe.withConfig */ .ZP.iframe.withConfig({
    displayName: "style__IframeStyled",
    componentId: "sc-5c3f9880-4"
})(_templateObject5());


/***/ }),

/***/ 19245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getRatio; }
/* harmony export */ });
function getRatio() {
    var ratio = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "1/1";
    return ({
        "4/3": "calc(100% / 4 * 3)",
        "3/4": "calc(100% / 3 * 4)",
        "6/4": "calc(100% / 6 * 4)",
        "4/6": "calc(100% / 4 * 6)",
        "16/9": "calc(100% / 16 * 9)",
        "9/16": "calc(100% / 9 * 16)",
        "21/9": "calc(100% / 21 * 9)",
        "9/21": "calc(100% / 9 * 21)",
        "1/1": "100%"
    })[ratio];
}


/***/ })

}]);